// extracted by mini-css-extract-plugin
export default {"container":"PublicLayoutProducts_container__pm0o0"};